import { Theme } from "@material-ui/core/styles";
import { CSSProperties } from "@material-ui/core/styles/withStyles";

export const styles = (theme: Theme): Record<string, CSSProperties> => ({
  background: {},
  divider: {
    backgroundColor: theme.palette.common.white,
    marginBottom: 10,
    marginTop: 10,
  },
  gritLogo: {
    marginTop: "0.5rem",
  },
  innerSidebar: {
    height: "100%",
    padding: 10,
    width: "100%",
    scrollbarWidth:"thin",
    overflowY:"auto",
    overflowX:"hidden",
  },
  linkContainer: {
    width: "100%",
  },
  logoContainer: {
    height: "130px",
  },
  schoolLogo: {
    height: 50,
    width: 50,
  },
  schoolText: {
    color: "white",
    fontSize: 15,
    padding: 5,
    textAlign: "center",
  },
  sendEvalButton: {
    "&:hover": {
      background: theme.palette.primary.main,
      borderRadius: 3,
    },
    backgroundColor: theme.palette.primary.main,
    borderRadius: 3,
    boxShadow: "0px 0px 15px hsla(0, 0%, 0%, 0.9)",
    color: theme.palette.common.white,
  },
  sidebar: {
    height: "100%",
    overflow: "hidden",
  },
  sidebarBackground: {
    backgroundSize: "cover",
    height: "100%",
  },
});



// WEBPACK FOOTER //
// ./src/pages/director/DirectorSidebar/styles.ts